import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { setSort } from "../../actions/advancedListActions";
import { Table } from "./Tables";

function SortableTableContainer({ storeKey, ...props }) {
  const sort = useSelector((state) => state[storeKey].sort);
  const dispatch = useDispatch();
  return (
    <Table
      {...props}
      sort={sort}
      onSort={(value) => dispatch(setSort(storeKey, value))}
    />
  );
}

SortableTableContainer.propTypes = {
  storeKey: PropTypes.string.isRequired,
};

export default SortableTableContainer;
